
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;

  var P = DL.ctx.product;
  if (!P || !P.id) return;

  /* ================================================================ */
  
  /* ================================================================ */

  var C = {
    main:      { component_id: 'pdp_main',                placement: 'pdp_primary' },
    benefits:  { component_id: 'pdp_benefits',            placement: 'pdp_primary' },
    media:     { component_id: 'pdp_media',               placement: 'pdp_gallery' },
    variant:   { component_id: 'pdp_variant_selector',    placement: 'pdp_purchase_config' },
    bundleCmp: { component_id: 'pdp_bundle_compare',      placement: 'pdp_purchase_config' },
    accessory: { component_id: 'pdp_accessory_selector',  placement: 'pdp_purchase_config' },
    care:      { component_id: 'pdp_dji_care',            placement: 'pdp_purchase_config' },
    buyMain:   { component_id: 'pdp_purchase_main',       placement: 'pdp_primary' },
    buySticky: { component_id: 'pdp_purchase_sticky',     placement: 'pdp_sticky' },
    bis:       { component_id: 'pdp_back_in_stock',       placement: 'pdp_availability' },
    scroll:    { component_id: 'pdp_scroll_depth',        placement: 'pdp_document' },
    story:     { component_id: 'pdp_story_gallery',       placement: 'pdp_story' },
    compare:   { component_id: 'pdp_comparison',          placement: 'pdp_comparison' },
    faq:       { component_id: 'pdp_faq',                 placement: 'pdp_faq' },
    expert:    { component_id: 'pdp_expert_support',      placement: 'pdp_faq_footer' }
  };

  
  
  var SEL = {
    
    mainRoot:    'product-info[id^="MainProduct"]',
    drawerRoot:  '.drawer-body, .quick-view-content, cart-drawer, mobile-menu, [mobile-drawer-content]',
    mainForm:    'product-info[id^="MainProduct"] form[action*="/cart/add"]',
    mainAdd:     'product-info[id^="MainProduct"] form[action*="/cart/add"] button[name="add"], product-info[id^="MainProduct"] form[action*="/cart/add"] [type="submit"]',
    
    /* El botón de pago acelerado vive en shadow DOM: a nivel window e.target es el host
       (<shopify-accelerated-checkout>, <shop-pay-wallet-button>…), por eso se casa el host. */
    payButton:   'shopify-accelerated-checkout, shop-pay-wallet-button, shopify-buy-it-now-button, .shopify-payment-button, .shopify-payment-button__button, [name="checkout"]',

    stickyBar:   '.dji-sticky-bar',
    stickyAdd:   '[data-dji-sticky-atc-btn]',
    stickyBuy:   '[data-dji-sticky-checkout-form], [data-dji-sticky-buy-btn]',

    
    benefitRow:  '.dji-pib-delivery, .dji-pib-features',
    benefitChev: '.dji-pib-delivery-chevron',

    gallery:     '.dji-hero-gallery',                  
    galleryDot:  '[data-dji-hero-dot]',                
    galleryPrev: '[data-dji-hero-prev]',
    galleryNext: '[data-dji-hero-next]',
    gallerySlide:'[data-dji-hero-slide]',              
    
    mediaTab:    '[data-dji-pvt-tab], .dji-pvt__tab',  
    mediaTabHost:'.dji-pvt__tabs',

    comboRoot:   '[data-dji-combo-swatch]',            
    comboCard:   '.dji-cs-snippet__card',              
    comboTitle:  '.dji-cs-snippet__title',

    
    bundleCompare:'[data-pkgcmp-toggle]',              
    bundleRoot:  '[data-dji-package-compare]',         

    accessoryRoot:'.dji-accessory-section',
    accessoryCard:'[data-accessory-card]',             
    
    accessoryChk:'.dji-addon-card__checkbox',          
    
    accessoryQty: '.dji-qty-input',                    
    accessoryDet: '[data-open-acc-modal]',             

    careRoot:    '.dji-care-section',
    careCard:    '[data-care-card]',                   
    careChk:     '.dji-addon-card__checkbox',
    
    careDecline: '.dji-care-no-thanks-card',           
    careDet:     '[data-open-care-modal]',             

    bisBlock:    '.back-in-stock-alert-block',         
    bisBtn:      '.back-in-stock-btn',
    bisForm:     '.back-in-stock-alert-block form',

    storyRoot:   '.section-dji-tus-momentos',
    storyTab:    '[data-dji-tm-tab], .dji-tm__tabs button, .dji-tm__tabs [role="tab"]',
    
    storyActive: '.dji-tm__tab--active',

    compareRoot: '.section-dji-product-compare',
    compareBtn:  '.dji-compare__btn',                  

    faqRoot:     '.dji-faq-wrapper',
    faqItem:     '.dji-faq-item',                      
    faqQuestion: '.dji-faq-question',
    expertLink:  '.dji-faq-cta-link'
  };
  /* ================================================================ */
  
  /* ================================================================ */

  var CATS = DL.productCategories(P.id);

  function all(root, sel) { return root ? [].slice.call(root.querySelectorAll(sel)) : []; }
  function txt(el) { return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : ''; }
  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect(), s = w.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && r.width > 0 && r.height > 0;
  }

  function formVariantId() {
    
    var inputs = [].slice.call(d.querySelectorAll(SEL.mainForm + ' input[name="id"]'));
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].closest(SEL.drawerRoot)) continue;
      if (inputs[i].value) return String(inputs[i].value);
    }
    return '';   
  }
  function currentVariantId() { return formVariantId() || String(P.selected_variant_id || ''); }
  function variantOf(id) { return (P.variants || {})[String(id)] || null; }
  function availabilityOf(vid) {
    var v = variantOf(vid);
    return v ? (v.available ? 'in_stock' : 'out_of_stock') : undefined;
  }

  function buildItem(variantId, extra) {
    extra = extra || {};
    var vid = String(variantId || currentVariantId());
    var v = variantOf(vid);
    return DL.clean({
      item_id: String(P.id),
      item_name: P.title,
      item_brand: DL.ctx.brand || 'DJI',
      item_category: CATS.item_category,
      item_category2: CATS.item_category2,
      item_category3: CATS.item_category3,
      item_series: CATS.item_series,
      item_model: P.title,
      item_variant: v ? v.title : undefined,
      selected_variant_id: vid || undefined,
      product_handle: P.handle,
      availability: v ? (v.available ? 'in_stock' : 'out_of_stock') : undefined,
      price: v ? DL.money(v.price) : undefined,
      quantity: extra.quantity == null ? 1 : extra.quantity,
      item_list_id: extra.item_list_id,
      item_list_name: extra.item_list_name,
      index: extra.index
    });
  }

  function itemValue(item) {
    if (!item || item.price == null) return undefined;
    return Math.round(item.price * (item.quantity || 1) * 100) / 100;
  }

  
  function base(cfg, extra) {
    var vid = currentVariantId();
    var out = {
      page_type: 'product',
      component_id: cfg.component_id,
      placement: cfg.placement,
      item_id: String(P.id),
      product_handle: P.handle,
      selected_variant_id: vid || undefined
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  /* ================================================================ */
  /* P1 · view_item                                                    */
  /* ================================================================ */

  function ready(vid) {
    var v = variantOf(vid);
    return !!(v && v.price != null && typeof v.available === 'boolean');
  }

  function pushViewItem(vid, reason) {
    if (!ready(vid)) return;
    if (!DL.once('view_item|' + vid)) return;
    var item = buildItem(vid);
    DL.push('view_item', base(C.main, {
      availability: item.availability,
      value: itemValue(item),
      view_reason: reason,
      items: [item]
    }));
  }

  function initViewItem() {
    var tries = 0;
    (function wait() {
      var vid = currentVariantId();
      if (ready(vid)) { pushViewItem(vid, 'initial'); return; }
      if (++tries < 20) w.setTimeout(wait, 200);
    })();

    function onVariantChange(evt) {
      var v = evt && evt.detail && evt.detail.variant;
      if (!v || !v.id) return;
      var vid = String(v.id);
      P.variants = P.variants || {};
      P.variants[vid] = { title: v.title, price: v.price, available: !!v.available, sku: v.sku };
      pushViewItem(vid, 'variant_change');
    }
    d.addEventListener('variant:change', onVariantChange, true);
    all(d, 'product-form, ' + SEL.mainForm + ', product-info').forEach(function (el) {
      el.addEventListener('variant:change', onVariantChange);
    });

    var last = currentVariantId();
    w.setInterval(function () {
      var vid = currentVariantId();
      if (vid && vid !== last) { last = vid; pushViewItem(vid, 'variant_change'); }
    }, 800);
  }

  /* ================================================================ */
  
  /* ================================================================ */

  var handlers = [];
  function onClick(fn) { handlers.push(fn); }

  w.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    for (var i = 0; i < handlers.length; i++) {
      try { if (handlers[i](evt, t) === true) return; } catch (e) { DL.log('pdp click handler error', e); }
    }
  }, true);

  
  function contentMode(el) {
    if (!el) return undefined;
    if (el.closest('[data-open-acc-modal], [data-open-care-modal]') || /modal/i.test(el.className)) return 'modal';
    if (/drawer/i.test(el.className || '')) return 'drawer';
    return 'accordion';
  }

  /* ================================================================ */
  /* P1 · pdp_benefit_detail_open                                      */
  /* ================================================================ */

  function initBenefits() {
    onClick(function (evt, t) {
      var row = t.closest(SEL.benefitRow);
      if (!row) return;
      if (!DL.isInteractive(row)) return;

      var isDelivery = row.matches('.dji-pib-delivery');

      
      if (!isDelivery) {
        
        var target = d.getElementById('dji-feature-highlights')
                  || d.querySelector('.dji-feature-highlights')
                  || d.querySelector('[id*="feature-highlight"]')
                  || d.querySelector('[class*="dji-fh-wrapper"]')
                  || d.querySelector('[data-dji-pib-target]');
        if (!target || !visible(target)) return true;   
      }

      
      var item = t.closest('.dji-pib-delivery-item') || row;
      var label = txt(item).toLowerCase();
      var type = /env[íi]o|shipping/.test(label) ? 'shipping'
               : /cr[eé]dit|puntos|store/.test(label) ? 'store_credit'
               : /devol|return/.test(label) ? 'returns'
               : isDelivery ? undefined : 'features';

      DL.push('pdp_benefit_detail_open', base(C.benefits, {
        benefit_type: type,
        
        element_id: t.closest(SEL.benefitChev) ? 'benefit_arrow' : 'benefit_row',
        
        
        content_mode: isDelivery ? 'modal' : 'accordion'
      }));
      return true;
    });
  }

  /* ================================================================ */
  /* P2 · product_media_tab_select / product_media_select              */
  /* ================================================================ */

  function currentMediaId() {
    var active = d.querySelector(SEL.gallerySlide + '.is-active') || d.querySelector(SEL.gallerySlide);
    return active ? (active.getAttribute('data-media-id') || '') : '';
  }
  function currentMediaIndex() {
    var active = d.querySelector(SEL.gallerySlide + '.is-active');
    return active ? Number(active.getAttribute('data-index')) : undefined;
  }

  
  function initMediaSwipe() {
    var gal = d.querySelector(SEL.gallery);
    var track = gal && gal.querySelector('[class*="track"], [class*="slides"]');
    if (!track || track.__djiSwipe) return;
    track.__djiSwipe = 1;

    var lastIdx = -1;
    var settle = null;
    function slotNow() {
      var wdt = track.offsetWidth || 1;
      return Math.round(track.scrollLeft / wdt);
    }
    lastIdx = slotNow();

    track.addEventListener('scroll', function () {
      if (settle) w.clearTimeout(settle);
      settle = w.setTimeout(function () {
        var now = slotNow();
        if (now === lastIdx) return;
        var from = lastIdx;
        lastIdx = now;
        var slides = all(gal, SEL.gallerySlide);
        var toEl = slides[now];
        DL.push('product_media_select', base(C.media, {
          element_id: 'media_swipe',
          
          action: 'swipe',
          from_media_id: slides[from] ? (slides[from].getAttribute('data-media-id') || undefined) : undefined,
          selected_media_id: toEl ? (toEl.getAttribute('data-media-id') || undefined) : undefined,
          media_index: now,
          media_type: toEl && toEl.querySelector('video') ? 'video' : 'image'
        }));
      }, 200);
    }, { passive: true });
  }

  function initMedia() {
    
    onClick(function (evt, t) {
      var tab = t.closest(SEL.mediaTab);
      if (!tab) return;
      if (!DL.isInteractive(tab)) return;
      var label = txt(tab).toLowerCase();
      var isVideo = /present|video/.test(label);
      
      if (tab.classList.contains('is-active') || tab.classList.contains('dji-pvt__tab--active') ||
          tab.getAttribute('aria-selected') === 'true') return true;
      DL.push('product_media_tab_select', base(C.media, {
        element_id: isVideo ? 'media_tab_presentation' : 'media_tab_photos',
        media_type: isVideo ? 'video' : 'image',
        selected_media_id: currentMediaId()
      }));
      return true;
    });

    
    onClick(function (evt, t) {
      var dot = t.closest(SEL.galleryDot);
      var prev = t.closest(SEL.galleryPrev);
      var next = t.closest(SEL.galleryNext);
      if (!dot && !prev && !next) return;
      var fromId = currentMediaId();
      var action = dot ? 'thumbnail' : (next ? 'next' : 'previous');
      var elementId = dot ? 'thumbnail' : 'gallery_arrow';
      
      w.setTimeout(function () {
        var toId = currentMediaId();
        if (!toId || toId === fromId) return;   
        DL.push('product_media_select', base(C.media, {
          element_id: elementId,
          action: action,
          from_media_id: fromId || undefined,
          selected_media_id: toId,
          media_index: currentMediaIndex(),
          media_type: 'image'
        }));
      }, 260);
      return true;
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initVariantSelect() {
    onClick(function (evt, t) {
      var card = t.closest(SEL.comboRoot + ' ' + SEL.comboCard);
      if (!card) return;
      var href = card.getAttribute('href') || '';
      var targetPath = String(href).split('?')[0].split('#')[0];
      
      if (!targetPath || targetPath === w.location.pathname) return true;
      if (!DL.isInteractive(card)) return true;

      var cards = all(d.querySelector(SEL.comboRoot), SEL.comboCard);
      var idx = cards.indexOf(card);
      var toHandle = (targetPath.match(/\/products\/([^/?#]+)/) || [])[1] || '';
      var avail = card.getAttribute('data-child-available');

      DL.push('variant_select', base(C.variant, {
        previous_variant_id: currentVariantId() || undefined,
        option_name: 'bundle',
        option_value: txt(card.querySelector(SEL.comboTitle)) || toHandle,
        target_product_handle: toHandle,
        availability: avail === 'false' ? 'out_of_stock' : (avail === 'true' ? 'in_stock' : undefined),
        index: idx > -1 ? idx + 1 : undefined,
        destination_url: href
      }));
      return true;
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  function initBundleCompare() {
    
    function bindPkgScroll(scroller) {
      if (!scroller || scroller.__djiPkgScroll) return;
      scroller.__djiPkgScroll = 1;
      var maxPct = 0;
      scroller.addEventListener('scroll', function () {
        var vTotal = scroller.scrollHeight - scroller.clientHeight;
        var hTotal = scroller.scrollWidth - scroller.clientWidth;
        var total, pos;
        if (vTotal >= hTotal) { total = vTotal; pos = scroller.scrollTop; }
        else { total = hTotal; pos = scroller.scrollLeft; }
        if (total <= 0) return;
        var pct = Math.min(100, Math.round((pos / total) * 100));
        if (pct <= maxPct) return;
        maxPct = pct;
        [30, 50, 70, 100].forEach(function (th) {
          if (pct < th) return;
          if (!DL.once('component_scroll|package_compare|' + th)) return;
          DL.push('component_scroll_depth', base(C.bundleCmp, {
            scroll_percent: th,
            scroll_method: 'component',
            component_scrollable: true
          }));
        });
      }, { passive: true });
    }
    
    function bindOpenModalScrollers(tries) {
      var found = false;
      all(d, '.dji-pkgcmp__table-wrap').forEach(function (wrap) {
        if (wrap.clientHeight > 0 &&
            (wrap.scrollHeight > wrap.clientHeight + 8 || wrap.scrollWidth > wrap.clientWidth + 8)) {
          bindPkgScroll(wrap); found = true;
        }
      });
      if (!found && tries > 0) setTimeout(function () { bindOpenModalScrollers(tries - 1); }, 120);
    }

    onClick(function (evt, t) {
      var el = t.closest(SEL.bundleCompare);
      if (!el) return;
      if (!DL.isInteractive(el)) return true;
      DL.push('bundle_contents_open', base(C.bundleCmp, {
        element_id: 'compare_bundle_contents',
        selected_bundle_id: currentVariantId() || undefined,
        content_mode: contentMode(el)
      }));
      bindOpenModalScrollers(12);
      return true;
    });
  }

  /* ================================================================ */
  /* P3 · accessory_select / accessory_details_open                    */
  /* ================================================================ */

  
  function accChecked(card) {
    if (!card) return false;
    var chk = card.querySelector(SEL.accessoryChk);
    return !!(chk && chk.checked);
  }

  
  function accQty(card) {
    if (!card) return 0;
    var inp = card.querySelector(SEL.accessoryQty);
    var v = inp ? Number(inp.value) : 0;
    return isNaN(v) ? 0 : v;
  }

  
  function replacedAnother(card) {
    var grp = card.getAttribute('name') || card.getAttribute('data-group');
    if (!grp) return false;
    var root = card.closest(SEL.accessoryRoot) || d;
    return all(root, SEL.accessoryCard).some(function (c) {
      return c !== card && (c.getAttribute('name') || c.getAttribute('data-group')) === grp && !accChecked(c);
    });
  }

  function accInfo(card) {
    return {
      accessory_item_id: card ? (card.getAttribute('data-variant-id') || '') : '',
      accessory_item_name: txt(card && card.querySelector('[class*="title"], [class*="name"]')) || txt(card).slice(0, 40)
    };
  }

  function initAccessory() {
    
    onClick(function (evt, t) {
      var det = t.closest(SEL.accessoryDet);
      if (!det) return;
      if (!DL.isInteractive(det)) return true;
      var card = det.closest(SEL.accessoryCard);
      var info = accInfo(card);
      DL.push('accessory_details_open', base(C.accessory, {
        element_id: 'accessory_details',
        accessory_item_id: info.accessory_item_id || undefined,
        accessory_item_name: info.accessory_item_name || undefined,
        content_mode: 'modal'
      }));
      return true;
    });

    
    onClick(function (evt, t) {
      var qtyBtn = t.closest('.dji-qty-btn, [data-qty-step]');
      var card = t.closest(SEL.accessoryRoot + ' ' + SEL.accessoryCard);
      
      if (!card) {
        var modalAdd = t.closest('[data-acc-modal-add]');
        var dlg = modalAdd && modalAdd.closest('dialog');
        card = dlg && dlg.previousElementSibling;
        if (!card || !card.matches(SEL.accessoryCard)) return;
      }
      if (t.closest(SEL.accessoryDet)) return;   
      if (!DL.isInteractive(card)) return true;

      var info = accInfo(card);
      
      var before = accChecked(card);
      var beforeQty = accQty(card);

      
      if (card.__djiQtyTimer) { w.clearTimeout(card.__djiQtyTimer); }
      card.__djiQtyTimer = w.setTimeout(function () {
        card.__djiQtyTimer = null;
        var after = accChecked(card);
        var afterQty = accQty(card);
        var action;
        
        if (qtyBtn && afterQty !== beforeQty) action = 'quantity_change';
        else if (!before && after) action = replacedAnother(card) ? 'replace' : 'add';
        else if (before && !after) action = 'remove';
        if (!action) return;   
        DL.push('accessory_select', base(C.accessory, {
          parent_item_id: String(P.id),
          accessory_item_id: info.accessory_item_id || undefined,
          accessory_item_name: info.accessory_item_name || undefined,
          action: action,
          quantity: afterQty || 1
        }));
      }, 300);
      return true;
    });
  }

  /* ================================================================ */
  /* P3 · care_select / care_details_open                              */
  /* ================================================================ */

  function initCare() {
    onClick(function (evt, t) {
      var det = t.closest(SEL.careDet);
      if (!det) return;
      if (!DL.isInteractive(det)) return true;
      var card = det.closest(SEL.careCard);
      DL.push('care_details_open', base(C.care, {
        element_id: 'care_details',
        care_plan_id: card ? (card.getAttribute('data-variant-id') || undefined) : undefined,
        care_plan_name: txt(card && card.querySelector('[class*="title"], [class*="name"]')) || undefined,
        content_mode: 'modal'
      }));
      return true;
    });

    onClick(function (evt, t) {
      var root = t.closest(SEL.careRoot);
      if (!root) return;
      if (t.closest(SEL.careDet)) return;
      var decline = t.closest(SEL.careDecline);
      var card = t.closest(SEL.careCard);
      if (!card) {
        var cModalAdd = t.closest('[data-care-modal-add]');
        var cDlg = cModalAdd && cModalAdd.closest('dialog');
        var sib = cDlg && cDlg.previousElementSibling;
        if (sib && sib.matches(SEL.careCard)) card = sib;
      }
      if (!decline && !card) return;
      if (!DL.isInteractive(decline || card)) return true;

      
      var clickedInput = t.closest('input[type="checkbox"]');
      var before = clickedInput ? !clickedInput.checked : accChecked(card);
      /* Estado previo tomado en el clic (fase de captura): el tema desmarca los demás planes de forma
         síncrona en su change, así que contarlos después del timeout siempre daba 0 → nunca 'replace'. */
      function declineSelected() {
        return !!(decline && decline.classList &&
          (decline.classList.contains('dji-care-no-thanks-card--selected') || decline.classList.contains('is-selected')));
      }
      var declineBefore = declineSelected();
      var othersBefore = card ? all(root, SEL.careCard).filter(function (c) {
        return c !== card && accChecked(c);
      }).length : 0;
      w.setTimeout(function () {
        var action, planId, planName;
        if (decline) {
          /* solo al pasar a seleccionado; quitar "No, gracias" no es un rechazo */
          if (declineBefore || !declineSelected()) return;
          action = 'decline';
        } else {
          var after = accChecked(card);
          if (!before && after) action = othersBefore ? 'replace' : 'select';
          else if (before && !after) return;    
          else return;                          
          planId = card.getAttribute('data-variant-id') || undefined;
          planName = txt(card.querySelector('[class*="title"], [class*="name"]')) || undefined;
        }
        DL.push('care_select', base(C.care, {
          element_id: decline ? 'care_decline' : 'care_plan',
          care_plan_id: planId,
          care_plan_name: planName,
          action: action,
          parent_item_id: String(P.id)
        }));
      }, 300);
      return true;
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  
  var intent = null;

  
  function setIntent(source, action, extra) {
    if (source === 'main' && intent && intent.source === 'sticky' && Date.now() - intent.at < 1500) {
      DL.log('pdp intent: 保留 sticky 归因，忽略合成的 main 点击');
      return;
    }
    intent = {
      at: Date.now(), source: source, action: action,
      variant_id: currentVariantId(),
      add_method: (extra && extra.add_method) || 'product_form',
      button_implementation: (extra && extra.button_implementation) || 'theme_product_form'
    };
    DL.log('pdp intent', intent);
  }
  w.__djiSetPdpIntent = function (source, action, variantId) {

    if (action === 'buy_now') action = 'begin_checkout';
    /* begin_checkout ya se envió en el clic (pago acelerado, no pasa por /cart/add): no dejar
       un intent residual que atribuiría a sticky el próximo add_to_cart */
    if (action === 'begin_checkout' && Date.now() - (checkoutSentAt[source] || 0) < 2000) return;
    setIntent(source, action, {
      add_method: source === 'sticky' ? 'ajax' : 'product_form',
      button_implementation: source === 'sticky' ? 'custom_ajax' : 'theme_product_form'
    });
  };

  function cartType() {
    return (DL.ctx.cart_type === 'drawer' || DL.ctx.cart_type === 'notification') ? 'drawer' : 'page';
  }

  function initPurchaseIntent() {
    onClick(function (evt, t) {
      var sAdd = t.closest(SEL.stickyAdd);
      if (sAdd) { if (DL.isInteractive(sAdd)) setIntent('sticky', 'add_to_cart', { add_method: 'ajax', button_implementation: 'custom_ajax' }); return true; }
      var pay = t.closest(SEL.payButton);
      var sBuy = t.closest(SEL.stickyBuy) || (pay && t.closest(SEL.stickyBar));
      if (sBuy) {
        if (pay && DL.isInteractive(pay)) emitCheckout('sticky');
        return true;
      }

      var mAdd = t.closest(SEL.mainAdd);
      if (mAdd) { if (DL.isInteractive(mAdd)) setIntent('main', 'add_to_cart'); return; }
      if (pay && t.closest(SEL.mainRoot)) {
        if (!DL.isInteractive(pay)) return;
        emitCheckout('main');
        return;
      }
    });
  }


  var checkoutSentAt = { main: 0, sticky: 0 };

  /* Pago acelerado (Shop Pay / Comprar ya): no pasa por /cart/add, así que se envía en el clic */
  function emitCheckout(slot) {
    if (Date.now() - checkoutSentAt[slot] < 2000) return;
    checkoutSentAt[slot] = Date.now();
    intent = null;
    var isSticky = slot === 'sticky';
    var vid = currentVariantId();
    var item = buildItem(vid, { quantity: 1 });
    if (!item) return;
    DL.push('begin_checkout', base(isSticky ? C.buySticky : C.buyMain, {
      element_id: isSticky ? 'sticky_begin_checkout' : 'begin_checkout',
      cart_type: cartType(),
      checkout_method: 'direct',
      value: itemValue(item),
      items: [item],
      item_category: CATS.item_category,
      item_series: CATS.item_series
    }));
  }

  function initPurchaseEvents() {
    DL.onCartSuccess(function (kind, body) {
      if (kind !== 'add') return;
      var ctx = intent && Date.now() - intent.at < 10000 ? intent : null;

      
      var firstVid = String((body && body.items && body.items[0] && body.items[0].variant_id) ||
                            (body && body.id) || '');
      if (!ctx && !(firstVid && (P.variants || {})[firstVid])) {
        DL.log('add_to_cart: 非本商品主购买区的加购，跳过', firstVid);
        return;
      }

      var source = ctx ? ctx.source : 'main';
      var cfg = source === 'sticky' ? C.buySticky : C.buyMain;
      var isSticky = source === 'sticky';
      intent = null;

      var lines = [];
      if (body && body.items && body.items.length) lines = body.items;
      else if (body && body.id) lines = [body];

      
      (function (cart) {
        
        var items = lines.length
          ? DL.itemsFromCartLines(lines, { item_category: CATS.item_category, item_series: CATS.item_series })
          : [buildItem(ctx ? ctx.variant_id : null)].filter(Boolean);
        if (!items.length) return;
        var value = DL.itemsValue(items);
        var vid = String((lines[0] && lines[0].variant_id) || (ctx && ctx.variant_id) || '');

        DL.push('add_to_cart', base(cfg, {
          element_id: isSticky ? 'sticky_add_to_cart' : 'add_to_cart',
          selected_variant_id: vid || undefined,
          availability: availabilityOf(vid),
          quantity: (lines[0] && lines[0].quantity) || (items[0] && items[0].quantity),
          add_method: ctx ? ctx.add_method : 'product_form',
          button_implementation: ctx ? ctx.button_implementation : 'theme_product_form',
          value: value,
          items: items
        }));

        
        if (ctx && ctx.action === 'begin_checkout') {
          var slot = isSticky ? 'sticky' : 'main';
          if (Date.now() - (checkoutSentAt[slot] || 0) > 2000) {
            checkoutSentAt[slot] = Date.now();
            DL.push('begin_checkout', base(cfg, {
              element_id: isSticky ? 'sticky_begin_checkout' : 'begin_checkout',
              cart_type: cartType(),
              checkout_method: 'direct',
              
              value: value,
              items: items,
              item_category: CATS.item_category,
              item_series: CATS.item_series
            }));
          }
        }
      })(null);
    });
  }

  /* ================================================================ */
  /* P4 · back_in_stock_subscribe                                      */
  /* ================================================================ */

  function initBackInStock() {
    var pending = null;
    d.addEventListener('submit', function (evt) {
      var f = evt.target;
      if (!f || !f.closest || !f.closest(SEL.bisBlock)) return;
      pending = { at: Date.now(), variant_id: currentVariantId() };
    }, true);

    
    function emit() {
      if (!pending || Date.now() - pending.at > 15000) return;
      var p = pending; pending = null;
      DL.push('back_in_stock_subscribe', base(C.bis, {
        element_id: 'notify_me',
        selected_variant_id: p.variant_id || undefined,
        availability: availabilityOf(p.variant_id),
        result: 'success'
      }));
    }
    DL.onRequestSuccess(/back[-_]?in[-_]?stock|restock|notify|\/contact/i, emit);

    
    var flag = d.querySelector('[data-dji-bis-success]');
    if (flag) {
      var fv = flag.getAttribute('data-variant-id') || '';
      if (DL.onceSession('bis_success|' + ((DL.ctx.product || {}).id || '') + '|' + fv)) {
        DL.push('back_in_stock_subscribe', base(C.bis, {
          element_id: 'notify_me',
          selected_variant_id: fv || undefined,
          availability: availabilityOf(fv),
          result: 'success'
        }));
      }
    }

    var block = d.querySelector(SEL.bisBlock);
    if (block) {
      var mo = new MutationObserver(function () {
        if (!pending) return;
        var ok = block.querySelector('[class*="success"], [class*="exito"]');
        if (ok && visible(ok)) emit();
      });
      mo.observe(block, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ================================================================ */
  /* P4 · pdp_scroll_depth                                             */
  /* ================================================================ */

  function initScrollDepth() {
    DL.scrollDepth({ thresholds: [30, 50, 70, 100], key: 'pdp_scroll' }, function (pct) {
      var vid = currentVariantId();
      DL.push('pdp_scroll_depth', base(C.scroll, {
        scroll_percent: pct,
        scroll_method: 'document',
        availability: availabilityOf(vid),
        device_type: DL.deviceType(),
        page_language: DL.ctx.locale
      }));
    });
  }

  /* ================================================================ */
  /* P5 · product_story_tab_select                                     */
  /* ================================================================ */

  function initStory() {
    onClick(function (evt, t) {
      var root = t.closest(SEL.storyRoot);
      if (!root) return;
      var tab = t.closest(SEL.storyTab) || t.closest('[data-dji-tm-tabs] > *');
      if (!tab) return;
      
      if (tab.matches(SEL.storyActive)) return true;   
      var prev = root.querySelector(SEL.storyActive);
      var tabs = all(root, '[data-dji-tm-tabs] > *');
      w.setTimeout(function () {
        DL.push('product_story_tab_select', base(C.story, {
          element_id: 'story_tab',
          story_id: tab.getAttribute('data-story-id') || String(tabs.indexOf(tab)),
          story_name: txt(tab),
          previous_story_id: prev ? (prev.getAttribute('data-story-id') || String(tabs.indexOf(prev))) : undefined
        }));
      }, 220);
      return true;
    });
  }

  /* ================================================================ */
  /* P6 · view_item_section / select_item / component_scroll_depth     */
  /* ================================================================ */

  
  var compareIds = {};

  function prefetchCompareIds(root) {
    all(root, SEL.compareBtn).forEach(function (b) {
      var href = b.getAttribute('href') || b.getAttribute('data-href') || '';
      var h = (String(href).match(/\/products\/([^/?#]+)/) || [])[1];
      if (!h || compareIds[h] !== undefined) return;
      compareIds[h] = null;                       
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.id) return;
          compareIds[h] = String(j.id);
          
          compareNames[h] = j.title || '';
        })
        .catch(function () {});
    });
  }

  var compareNames = {};

  
  function initCompareObservers() {
    var root = d.querySelector(SEL.compareRoot);
    if (!root) return;
    
    var inner = root.firstElementChild;
    if (!inner || inner.__djiCompareObserved) return;
    inner.__djiCompareObserved = 1;
    prefetchCompareIds(root);
    
    if (initCompareObservers.__stop) { try { initCompareObservers.__stop(); } catch (e) {} }

    
    
    initCompareObservers.__stop = DL.observe(root, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
      if (!DL.once('view_item_section|product_comparison')) return;
      DL.push('view_item_section', base(C.compare, {
        section_id: 'product_comparison',
        section_name: txt(root.querySelector('h2, h3')) || 'product_comparison',
        visibility_percent: meta ? Math.round(meta.ratio_observed * 100) : undefined,
        engaged_time_ms: meta && meta.engaged_ms != null ? meta.engaged_ms : undefined
      }));
    });

    
    if (!initCompareObservers.__clicks) {
    initCompareObservers.__clicks = 1;
    onClick(function (evt, t) {
      var btn = t.closest(SEL.compareBtn);
      var cmpRoot = btn && btn.closest(SEL.compareRoot);
      if (!btn || !cmpRoot) return;
      var link = btn.matches('a[href]') ? btn : btn.closest('a[href]');
      var href = link ? link.getAttribute('href') : btn.getAttribute('data-href');
      if (!href) return true;
      var btns = all(cmpRoot, SEL.compareBtn);   
      var idx = btns.indexOf(btn);
      var toHandle = (String(href).match(/\/products\/([^/?#]+)/) || [])[1] || '';

      
      if (toHandle && P.handle && toHandle === P.handle) return true;
      DL.afterTick(function () {
        
        var __np = DL.navPush(evt, link || btn);
        if (!__np) return;
        __np('select_item', base(C.compare, {
          element_id: 'comparison_buy',
          item_list_id: 'pdp_comparison',
          item_list_name: txt(cmpRoot.querySelector('h2, h3')) || 'PDP Comparison',
          source_item_id: String(P.id),
          index: idx > -1 ? idx + 1 : undefined,
          destination_url: href,
          
          items: [DL.clean({
            
            item_id: compareIds[toHandle] || toHandle || undefined,
            
            item_name: compareNames[toHandle] ||
                       txt(btn.closest('[class*="dji-compare__col"], td, li')) || undefined,
            item_brand: DL.ctx.brand || 'DJI',
            product_handle: toHandle || undefined,
            index: idx > -1 ? idx + 1 : undefined,
            item_list_id: 'pdp_comparison',
            item_list_name: 'PDP Comparison'
          })]
        }));
      });
      return true;
    });
    }

    
    var scroller = null;
    all(root, '*').some(function (el) {
      var cs = w.getComputedStyle(el);
      if ((cs.overflowX === 'auto' || cs.overflowX === 'scroll' || cs.overflowY === 'auto' || cs.overflowY === 'scroll')
          && el.scrollWidth > el.clientWidth + 8) { scroller = el; return true; }
      return false;
    });
    if (!scroller) return;

    var maxPct = 0;
    scroller.addEventListener('scroll', function () {
      var total = scroller.scrollWidth - scroller.clientWidth;
      if (total <= 0) return;
      var pct = Math.min(100, Math.round((scroller.scrollLeft / total) * 100));
      if (pct <= maxPct) return;
      maxPct = pct;
      [30, 50, 70, 100].forEach(function (th) {
        if (pct < th) return;
        if (!DL.once('component_scroll|pdp_comparison|' + th)) return;
        DL.push('component_scroll_depth', base(C.compare, {
          scroll_percent: th,
          scroll_method: 'component',
          component_scrollable: true
        }));
      });
    }, { passive: true });
  }

  /* ================================================================ */
  /* P7 · faq_expand / expert_support_click                            */
  /* ================================================================ */

  function initFaq() {
    
    {
      onClick(function (evt, t) {
        var q = t.closest(SEL.faqQuestion);
        if (!q) return;
        var item = q.closest(SEL.faqItem);
        if (!item) return;
        var faqRoot = item.closest(SEL.faqRoot) || d;
        var items = all(faqRoot, SEL.faqItem);
        var wasOpen = item.classList.contains('is-open') || item.hasAttribute('open');
        if (wasOpen) return true;   
        var idx = items.indexOf(item);
        w.setTimeout(function () {
          var nowOpen = item.classList.contains('is-open') || item.hasAttribute('open');
          if (!nowOpen) return;     
          if (!DL.once('faq_expand|' + idx)) return;
          DL.push('faq_expand', base(C.faq, {
            faq_id: item.getAttribute('data-faq-id') || String(idx + 1),
            faq_question: txt(q),
            faq_index: idx > -1 ? idx + 1 : undefined
          }));
        }, 260);
        return true;
      });
    }

    onClick(function (evt, t) {
      var link = t.closest(SEL.expertLink);
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var channel = /chat/i.test(href) ? 'chat'
                  : /tel:/i.test(href) ? 'phone'
                  : /mailto:|contact/i.test(href) ? 'form'
                  : /^https?:/i.test(href) && href.indexOf(w.location.host) === -1 ? 'external' : 'chat';
      DL.afterTick(function () {
        if (!DL.isInteractive(link)) return;
        DL.push('expert_support_click', base(C.expert, {
          element_id: 'expert_support_link',
          support_channel: channel,
          destination_url: href || undefined
        }));
      });
      return true;
    });
  }

  /* ================================================================ */
  
  /* ================================================================ */

  
  function rewireSwappedSections() {
    try {
      
      initCompareObservers();
    } catch (e) { DL.log('rewire error', e); }
  }


  function initInstantSwitch() {
    w.addEventListener('dji:instant-switch-complete', function (evt) {
      var url = (evt && evt.detail && evt.detail.url) || w.location.href;
      var handle = (String(url).match(/\/products\/([^/?#]+)/) || [])[1];
      if (!handle || handle === P.handle) return;
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.id) return;
          var variants = {};
          (j.variants || []).forEach(function (v) {
            variants[String(v.id)] = { title: v.title, price: v.price, available: !!v.available, sku: v.sku };
          });
          P = {
            id: j.id, handle: j.handle, title: j.title, type: j.type, vendor: j.vendor,
            
            collections: P.collections,
            selected_variant_id: (j.variants && j.variants[0] && j.variants[0].id) || null,
            variants: variants
          };
          DL.ctx.product = P;
          
          CATS = DL.productCategories(P.id);
          DL.newPageView();
          
          rewireSwappedSections();
          pushViewItem(currentVariantId(), 'instant_switch');
        })
        .catch(function () {});
    });
  }

  /* ================================================================ */

  function start() {
    initViewItem();
    initBenefits();
    initMedia();
    initMediaSwipe();
    initVariantSelect();
    initBundleCompare();
    initAccessory();
    initCare();
    initPurchaseIntent();
    initPurchaseEvents();
    initBackInStock();
    initScrollDepth();
    initStory();
    initCompareObservers();
    initFaq();
    initInstantSwitch();
    DL.log('pdp tracking ready', P.handle);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})(window, document);
